module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ChapTitle1",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "DropText"
  }, [_c('span', {
    staticClass: "DropCap"
  }, [_vm._v("T")]), _vm._v("his book was first published in 1960 and reprinted in 1971; I do not think that much in it needs bringing up to date, excepting the comments on pornography. The past quarter century has seen a revolution in this sort of publishing, and writers now enjoy a freedom that would have roused the astonishment and envy of some of the greatest Victorians, and perhaps of Joyce and Lawrence. Whether the arts of the novel and the play have been correspondingly enlarged we cannot yet know, but it is plain that pornography as a genre in itself has entered on a new life. If I were to rewrite Chapter VII, I do not think I would strike anything out; rather, I should add some additional comment, but as I make no claim to being an expert in this realm, and write of pornography rather as an area for the collector than as a genre in itself, the reader will be just as well off without any extension of my opinions. There are references, also, to writers who were "), _c('em', {
    staticClass: "Italic"
  }, [_vm._v("avant-garde ")]), _vm._v("when the book was written and who are so no longer, though I do not think their work has lost much in value for that reason. Books of the "), _c('em', {
    staticClass: "Italic"
  }, [_vm._v("avant-garde ")]), _vm._v("either "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("establish themselves as books of lasting value, or they slip from the rear guard into the discard, and I believe the writers I mentioned have not proven trivial. This is, after all, a book about reading, and the kind of reader I am addressing does not care primarily about being in fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Robertson Davies")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0